import { lazy } from "react";
import React, { Suspense } from "react";
import { Route } from "react-router-dom";

import InfoLayout from "./InfoLayout";

export const routes = [
    {
        path: "/home",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/Home/Home")),
    },
    {
        path: "/list/:topicId",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/List/List")),
    },
    {
        path: "/show/:topicId",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/Show/Show")),
    },
    {
        path: "/board",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/Board/Board")),
        // component: lazy(() => (
        //     <div>
        //         {(() => {
        //             alert("ปิดเพื่อพัฒนาระบบชั่วคราว");
        //             window.location.href = "/home";
        //         })()}
        //     </div>
        // )),
    },
    {
        path: "/boardPost",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/Board/Board_post")),
    },
    {
        path: "/boardShow/:topicId",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/Board/Board_show")),
    },
    {
        path: "/demand",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/Demand/Demand")),
    },
    {
        path: "/showdemand/:topicId",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/Demand/ShowDemand")),
    },
    {
        path: "/election",
        exact: true,
        layout: "info",
        component: lazy(() => import("../pages/election/election_members")),
    },

    {
        path: "/load",
        exact: true,
        // layout: "info",
        // component: lazy(() => import("../pages/ImgPreview/imgpreview"))
        component: lazy(() => import("../components/Skeletion/MainLoading")),
    },
    {
        path: "/colors",
        exact: true,
        // layout: "info",
        // component: lazy(() => import("../pages/ImgPreview/imgpreview"))
        component: lazy(() => import("../pages/ColorPlate/ColorPlate")),
    },
    {
        path: "/loancal",
        exact: true,
        component: lazy(() => import("../pages/Calculate/cal_loan")),
    },
    {
        path: "/caldividend",
        exact: true,
        component: lazy(() => import("../pages/Calculate/cal_dividend")),
    },
    {
        path: "/cookie/:typecookie",
        exact: true,
        component: lazy(() => import("../components/ContentCookie")),
    },
];

const InfoRoute = ({ component: Component, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) => {
                return (
                    <Suspense fallback={<> </>}>
                        {/* <ScrollToTop /> */}
                        <InfoLayout>
                            <Component {...props} />
                        </InfoLayout>
                    </Suspense>
                );
            }}
        />
    );
};

export default InfoRoute;


